import { isSignalType, SignalDoc, signalTypeActionLabel } from "@megaron/docs-contracts";

export const signalTypeLabel = (signalType: string): string =>
  isSignalType(signalType) ? signalTypeActionLabel(signalType) : "Wymaga uwagi";

export const signalActionLabel = (signal: SignalDoc): string => signalTypeLabel(signal.signalType);
